import { useSelector } from 'react-redux'
import { selectDriversListStructure } from '@/features/domain/lists'
import { useEditingStateWithCtx } from '@/atoms'
import { useSearchList } from './useSearchList'

export function useFilter() {
  const { editing } = useEditingStateWithCtx('driver')
  const { query, setQuery } = useSearchList()
  const listStructure = useSelector(selectDriversListStructure)

  return {
    query,
    editing,
    setQuery,
    noEntries: listStructure.totalItems === 0,
  }
}
